import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PaymentChannelQueryCriteriaClass extends BaseCriteriaModel {
  //For bl_fi_mst_entity_hdr table
  name?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  ccy_code?: Optional<string> = Optional.empty();
  country_code?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //For ext
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
  ext_created_date?: Optional<string> = Optional.empty();
  ext_updated_date?: Optional<string> = Optional.empty();
  ext_status?: Optional<string> = Optional.empty();
  ext_guids?: Optional<string> = Optional.empty();
}

export class PaymentChannelCriteriaModelQuery {
  query = '';

  constructor(pcCriteriaModel: PaymentChannelQueryCriteriaClass) {
    console.log('pCCriteriaModel', pcCriteriaModel);

    if (!pcCriteriaModel) {
      return;
    }

    this.query += pcCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += pcCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += pcCriteriaModel.ccy_code.filter(x => x !== '').map(x => '&ccy_code=' + x).orElse('');
    this.query += pcCriteriaModel.country_code.filter(x => x !== '').map(x => '&country_code=' + x).orElse('');
    this.query += pcCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += pcCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += pcCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += pcCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += pcCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += pcCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += pcCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += pcCriteriaModel.ext_created_date.filter(x => x !== '').map(x => '&ext_created_date=' + x).orElse('');
    this.query += pcCriteriaModel.ext_updated_date.filter(x => x !== '').map(x => '&ext_updated_date=' + x).orElse('');
    this.query += pcCriteriaModel.ext_status.filter(x => x !== '').map(x => '&ext_status=' + x).orElse('');
    this.query += pcCriteriaModel.ext_guids.filter(x => x !== '').map(x => '&ext_guids=' + x).orElse('');


    this.query += '&status=' + pcCriteriaModel.status;
    this.query += '&orderBy=' + pcCriteriaModel.orderBy;
    this.query += '&order=' + pcCriteriaModel.order;
    this.query += '&offset=' + pcCriteriaModel.offset + '&limit=' + pcCriteriaModel.limit;
  }

}
